import { Component, OnInit, Input, Output, ViewChild, ElementRef, NgZone } from '@angular/core';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AgmCoreModule, MapsAPILoader } from '@agm/core';
// import { } from '@types/googlemaps';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrls: ['./map-popup.component.css']
})
export class MapPopupComponent implements OnInit {
  @ViewChild('contentMap') modal: ElementRef;
  public latitude = 40.7127837;
  public longitude = -74.00594130000002;
  address: string;
  public zoom = 15;
  constructor(private modalService: NgbModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  formatAddress(addr){
    let a = addr.replace(',','&').split('&')
    return a[0]
  }

  formatAddressAlt(addr){
    let a = addr.replace(',','&').split('&')
    return a[1]
  }

  showModal(lat, lng) {
    this.latitude = parseFloat(lat);
    this.longitude = parseFloat(lng);
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
};
    this.modalService.open(this.modal, ngbModalOptions);
  }
  showModalAddress(lat, lng, addr) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop : 'static',
      keyboard : false
};
    this.modalService.open(this.modal, ngbModalOptions);
    this.latitude = parseFloat(lat);
    this.longitude = parseFloat(lng);
    this.address = addr;
  }
  markerClick(address) {
    window.open('https://www.google.com/maps?z=12&t=m&q=loc:' + address, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/map-popup/map-popup.component.ts